import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GitBranch, MessageSquare, User } from 'lucide-react';
import { formatRelativeTime } from '../../utils/time';
/**
 * Displays a single project chat in the chat list.
 * Shows title, creator, activity time, message count, and ownership indicator.
 */ export function ChatCard({ chat, onClick }) {
    const { title, createdBy, createdAt, messageCount, isOwner, forkedFrom } = chat;
    return /*#__PURE__*/ _jsx("button", {
        type: "button",
        onClick: onClick,
        className: "w-full text-left p-4 border rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-700 dark:bg-gray-800",
        "data-testid": "chat-card",
        "aria-label": `Open chat: ${title}`,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-start justify-between",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex-1 min-w-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "font-medium text-gray-900 dark:text-gray-100 truncate",
                                    children: title
                                }),
                                isOwner && /*#__PURE__*/ _jsx("span", {
                                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300",
                                    children: "Your chat"
                                })
                            ]
                        }),
                        forkedFrom && /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-1 mt-1 text-xs text-gray-500 dark:text-gray-400",
                            children: [
                                /*#__PURE__*/ _jsx(GitBranch, {
                                    className: "w-3 h-3"
                                }),
                                /*#__PURE__*/ _jsxs("span", {
                                    children: [
                                        "Forked from ",
                                        forkedFrom.title
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-3 mt-2 text-sm text-gray-500 dark:text-gray-400",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ _jsx(User, {
                                            className: "w-4 h-4"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: createdBy.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: "•"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: formatRelativeTime(createdAt)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400",
                    children: [
                        /*#__PURE__*/ _jsx(MessageSquare, {
                            className: "w-4 h-4"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: messageCount
                        })
                    ]
                })
            ]
        })
    });
}
